import { EMPTY, MonoTypeOperatorFunction, catchError, finalize } from 'rxjs';
import { tap } from 'rxjs';
import {
  createRetryFetch$,
  flog,
  createDistributedObservable$,
} from '@lseg-ciam/auth/utils';
import type { TokenUpdate } from '@lseg-ciam/auth/token';

const CDN_RELAY_URL_KEY = 'heimdall:cdn-relay-url';
const DEFAULT_CDN_RELAY_URL = '/auth/heimdall';

const cdnRelayUrl = () =>
  globalThis.localStorage?.getItem(CDN_RELAY_URL_KEY) || DEFAULT_CDN_RELAY_URL;

export function configureCdnRelayUrl(url: string): void {
  if (!url.trim()) {
    throw new Error('CDN relay URL must not be empty');
  }
  globalThis.localStorage?.setItem(CDN_RELAY_URL_KEY, url);
}

export function postCdnToken$(token: string) {
  return createRetryFetch$(cdnRelayUrl(), {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    skipParse: true,
  });
}

export function deleteCdnCookie$(persist = false) {
  const baseUrl = cdnRelayUrl();
  const querySeparator = baseUrl.includes('?') ? '&' : '?';
  const url = persist ? `${baseUrl}${querySeparator}persist=true` : baseUrl;
  return createRetryFetch$(url, {
    method: 'DELETE',
    skipParse: true,
  });
}

const CDN_LOCK = 'heimdall:cdn-relay';

export function withCdnRelay(): MonoTypeOperatorFunction<TokenUpdate> {
  return (source$) =>
    createDistributedObservable$<TokenUpdate>(CDN_LOCK, (o) =>
      source$
        .pipe(
          tap((update) => {
            postCdnToken$(update.token)
              .pipe(
                flog('CDN relay'),
                catchError(() => EMPTY)
              )
              .subscribe();
          }),
          finalize(() => {
            deleteCdnCookie$()
              .pipe(
                flog('CDN teardown'),
                catchError(() => EMPTY)
              )
              .subscribe();
          })
        )
        .subscribe(o)
    );
}
